import { type SuggestedPromptTile } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { PRIMARY_PROMPTS_COUNT } from './PRIMARY_PROMPTS_COUNT';

export const getSecondaryPrompts: (tiles: SuggestedPromptTile[]) => SuggestedPromptTile[] = (
	tiles,
) => tiles.slice(PRIMARY_PROMPTS_COUNT);
